<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-col
                cols="4"
              >
                <v-text-field
                  v-model="search"
                  placeholder="Key in Leave Entitlement Setting name here"
                  append-icon="search"
                  label="Search Leave Entitlement Setting"
                  hide-no-data
                  hide-selected
                  clearable 
                />
              </v-col>
              <v-col
                cols="4"
              >
                <v-select
                  v-model="statusFilter"
                  :items="items"
                  item-text="state"
                  item-value="value"
                  label="Leave Entitlement Setting's Status"
                  placeholder="Active / Deleted"
                />
              </v-col>
              <v-col
                cols="2"
                offset-md="2"
              >
                <setup-leaves-entitlement-settings-dialog-create 
                  @created="loadData"
                />
              </v-col>
            </v-row>
          </v-card-actions>
          <v-data-table
            :headers="headers"
            :items="filteredLeaveEntitlementSettings"
            :single-expand="true"
            show-expand
            :search="search"
          >
            <template v-slot:item="props">
              <tr>
                <td :class="props.isExpanded?'remove-bottom-border':'border-bottom'">
                  <v-btn
                    icon
                    @click="props.expand(!props.isExpanded)"
                  >
                    <v-icon small> 
                      {{ props.isExpanded ? 'fa-chevron-up':'fa-chevron-down' }} 
                    </v-icon>
                  </v-btn>
                </td>

                <td :class="props.isExpanded? 'remove-bottom-border':'border-bottom' ">
                  <span class="font-weight-bold">
                    {{ props.item.name }}
                  </span>
                </td>

                <td :class="props.isExpanded? 'remove-bottom-border':'border-bottom' ">
                  <span class="font-weight-bold">
                    {{ ((props.item||{}).leave_type ||{}).name || 'N/A' }}
                  </span>
                </td>

                <td :class="props.isExpanded? 'remove-bottom-border':'border-bottom' ">
                  <span v-if="statusFilter">
                    <!-- <setup-leaves-entitlement-settings-dialog-edit 
                      :setting="props.item"
                      @updated="loadData"
                    /> -->
                    <span class="mx-1" />
                    <setup-leaves-entitlement-settings-dialog-delete
                      :setting="props.item"
                      @deleted="loadData"
                    />
                  </span>
                  <span v-else>
                    <setup-leaves-entitlement-settings-dialog-restore
                      :setting="props.item"
                      @restored="loadData"
                    />
                  </span>
                </td>
              </tr>
            </template>
            
            <template v-slot:expanded-item="{ headers, item }">   
              <td
                class="details pb-3"
                :colspan="12"
              >
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Start Day
                        </th>
                        <th class="text-left">
                          End Day
                        </th>
                        <th class="text-left">
                          Days
                        </th>
                        <th class="text-left">
                          Maximum Carry Forward Days
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(detail,index) in item.leave_entitlement_setting_details"
                        :key="index"
                      >
                        <td>{{ detail.start_day }}</td>
                        <td>{{ detail.end_day }}</td>
                        <td>{{ detail.days }}</td>
                        <td>{{ detail.maximum_carry_forward_days }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </td>
            </template>
          </v-data-table>
        </v-card> 
      </v-col>
    </v-row>    
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupLeavesEntitlementSettingsDialogCreate: () => import('@/components/setup/leaves/entitlement-settings/DialogCreate'),
      // SetupLeavesEntitlementSettingsDialogEdit: () => import('@/components/setup/leaves/entitlement-settings/DialogEdit'),
      SetupLeavesEntitlementSettingsDialogDelete: () => import('@/components/setup/leaves/entitlement-settings/DialogDelete'),
      SetupLeavesEntitlementSettingsDialogRestore: () => import('@/components/setup/leaves/entitlement-settings/DialogRestore'),
    },
    data () {
      return {    
        headers: [
          {
            text: 'Leave Entitlement Settings Name',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Leave Type',
            align: 'left',
            value: 'leave_type.name',
          },
          {
            text: 'Actions',
            sortable: false,
            value: 'action',
          },
        ],
        detailHeaders: [
          {
            text: 'Start Day',
            value: 'start_day',
            sortable: false,
          },
          {
            text: 'End Day',
            value: 'end_day',
            sortable: false,
          },
          {
            text: 'Days',
            value: 'days',
            sortable: false,
          },
          {
            text: 'Maximum Carry Forward Days',
            value: 'maximum_carry_forward_days',
            sortable: false,
          },
        ],
        leaveEntitlementSettings: [],
        trashedLeaveEntitlementSettings: [],
        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
      }
    },
    computed: {
      filteredLeaveEntitlementSettings () {
        return this.statusFilter ? this.leaveEntitlementSettings : this.trashedLeaveEntitlementSettings
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.loadLeaveEntitlementSettings()
        this.loadTrashedLeaveEntitlementSettings()
      },

      loadLeaveEntitlementSettings () {
        this.$api.leaveEntitlementSettings().list()
          .then(res => {
            this.leaveEntitlementSettings = res.data
          })
      },
      loadTrashedLeaveEntitlementSettings () {
        this.$api.leaveEntitlementSettings().listTrashed()
          .then(res => {
            this.trashedLeaveEntitlementSettings = res.data
          })
      },
    },
  }
</script>

<style scoped>
.details {
    padding-left:85px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    padding-right:85px;
}

.remove-bottom-border {
    border-bottom: 0px !important
}

.border-bottom {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important
}
</style>
